(function () {
  'use strict';

  var MEASUREMENT_ID = 'G-G4D3HR44CE';
  var CONSENT_KEY = 'pbsco_consent';
  var WRITTEN_KEY = 'pbsco_ga_ids_on_cart';
  var POLL_MS = 500;
  var MAX_POLLS = 20;

  var polls = 0;

  function cookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function hasDeclined() {
    try {
      return localStorage.getItem(CONSENT_KEY) === 'declined';
    } catch (e) {
      return false;
    }
  }

  // `_ga` looks like GA1.1.1234567890.1700000000 - client_id is the last two parts.
  function clientId() {
    var raw = cookie('_ga');
    if (!raw) return null;
    var parts = raw.split('.');
    return parts.length < 4 ? null : parts.slice(-2).join('.');
  }

  // `_ga_<STREAM>` is either GS1.1.1700000000.5.1... or GS1.1.s1700000000$o5$g1...
  // session_id is the first 10-digit timestamp after the prefix.
  function sessionId() {
    var raw = cookie('_ga_' + MEASUREMENT_ID.replace('G-', ''));
    if (!raw) return null;
    var match = raw.match(/GS\d+\.\d+\.s?(\d{10})/);
    return match ? match[1] : null;
  }

  function alreadyWritten(stamp) {
    try {
      return sessionStorage.getItem(WRITTEN_KEY) === stamp;
    } catch (e) {
      return false;
    }
  }

  function remember(stamp) {
    try {
      sessionStorage.setItem(WRITTEN_KEY, stamp);
    } catch (e) {}
  }

  function write(client, session) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var attributes = { ga_client_id: client };
    if (session) attributes.ga_session_id = session;

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true
    }).catch(function () {});
  }

  function attempt() {
    // Declining clears the _ga cookie, but the banner can resolve after this
    // script has started polling - so check the stored choice, not the cookie.
    if (hasDeclined()) return;

    var client = clientId();
    if (!client) {
      // GA4 writes _ga asynchronously, so it is usually absent on first paint.
      polls++;
      if (polls < MAX_POLLS) setTimeout(attempt, POLL_MS);
      return;
    }

    // Re-writing on every page view would POST a cart update per page load.
    // The stamp changes when GA4 rolls the session, which is when it matters.
    var session = sessionId();
    var stamp = client + '|' + (session || '');
    if (alreadyWritten(stamp)) return;

    write(client, session);
    remember(stamp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt);
  } else {
    attempt();
  }
})();
